import React, { Component } from 'react';
import { Modal, Col } from "react-bootstrap";

class CustomModal extends Component {
    state = {
        show: this.props.isopen,
    }

    cerrarModal = () => (e) => {
        if(this.props.funcion2 === undefined) {
            this.setState({ show: false });
        }else{
            this.props.funcion2()
        }
        
    }

    componentWillReceiveProps (props) {
        this.setState({
            show: props.isopen
        });
    }
    
    botones = () => {
        const { boton1, boton2, funcion1 } = this.props;
        if (boton1 === "" && boton2 === "") return null;
        if (boton1 === "") {
            return (
                <button className="btn btn-primary" onClick = {this.cerrarModal()} style={{borderWidth:1}}>
                    {boton2}
                </button>
            );
        }

        if (boton2 === "") {
            return (
                <button className="btn btn-default" onClick = {funcion1} style={{borderWidth:1}}>
                    {boton1}
                </button>
            );
        }

        return (
            <React.Fragment>
                <button className="btn btn-default" onClick = {funcion1} style={{borderWidth:1}}>
                    {boton1}
                </button>
                <button className="btn btn-primary" onClick = {this.cerrarModal()} style={{borderWidth:1}}>
                    {boton2}
                </button>
            </React.Fragment>
        );
    }

    render() {
        const { titulo, contenido, large, backgroundColor } = this.props;
        return (
            <Modal bsSize ={large} backdrop ="static" show = {this.state.show} onHide = {this.cerrarModal()}>
                <Modal.Header 
                    closeButton = {false} style={{backgroundColor: backgroundColor, borderTopLeftRadius: 4, borderTopRightRadius: 4}}>
                    <Modal.Title>{titulo}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{contenido}</Modal.Body>
                <Modal.Footer style={{padding:5}}>
                    <Col md ={4} sm ={6} align="left">
                        
                    </Col>
                    <Col md ={8} sm ={6}>
                        {this.botones()}
                    </Col>
                </Modal.Footer>
            </Modal>
        );
    }
}
 
export default CustomModal;


// WEBPACK FOOTER //
// ./src/components/Modal/CustomModal.jsx